module.exports = __webpack_public_path__ + "img/LOGO NEGATIVO SIN FONDO.718ce870.png";